export default __webpack_public_path__ + "static/favicon-b5d9d017ccf69b481994727ac209196b.svg";